
import { types, actions } from './requests'
export const CREATEPICTURE_TYPES = {
    ...types('CREATEPICTURE'),
}
export const CREATEPICTURE_ACTIONS = {
    ...actions('CREATEPICTURE'),
}